module.exports = __webpack_public_path__ + "img/arrow_black.ebb210a2.svg";